import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import ScrollToTop from './components/ScrollToTop';
import HomePage from './Views/HomePage';
import AboutPage from './Views/AboutPage';
import ServicesHubPage from './Views/ServicesHubPage';
import ServiceLinePage from './Views/ServiceLinePage';
import ContactPage from './Views/ContactPage';
import PrivacyPolicy from './Views/PrivacyPolicy';
import Media from './Views/Media';
import Signup from './Views/Signup';
import Login from './Views/Login';

import ForgotPassword from './components/ForgotPassword';
import EnsureForgotPassword from './components/EnsureForgotPassword';
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';

import { PlaceholderPage, ClientAdminPlaceholder } from './Views/PlaceholderPage';

function App() {
    return (
        <AuthProvider>
            <Router>
                <ScrollToTop />
                <div className="App">
                    <Routes>

                        {/* Public Routes */}
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/services" element={<ServicesHubPage />} />
                        <Route
                            path="/services/advisory"
                            element={<Navigate to="/services/consulting" replace />}
                        />
                        <Route
                            path="/services/ventures"
                            element={<Navigate to="/services/capital" replace />}
                        />
                        <Route path="/services/:slug" element={<ServiceLinePage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/media" element={<Media />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/forgot-password"
                            element={
                                <EnsureForgotPassword>
                                    <ForgotPassword />
                                </EnsureForgotPassword>
                            }
                        />

                        {/* Private Routes */}
                        <Route
                            path="/dashboard"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="Rule Engine" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/pdf-summary"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="PDF Summary" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/fields"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="Fields" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/rules"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="Rules" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/staticdata"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="Static Data" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/entity-matching"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="Entity Matching" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/resolve"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="Match Resolution" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/mappings"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="Field Mapping Admin" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/voice"
                            element={
                                <PrivateRoute>
                                    <PlaceholderPage title="Voice Assistant" />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/client/:clientId"
                            element={
                                <PrivateRoute>
                                    <ClientAdminPlaceholder />
                                </PrivateRoute>
                            }
                        />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;